<div class="container-fluid main-card">
    <div class="row">
        <div class="col-12">
            <h1 class="tools">
                Simulateur de fiscalité locative
                <span>Simulez vos impôts et comparez les régimes fiscaux entre eux</span>
            </h1>
        </div>
    </div>
    <div class="row mb-4">
        <div class="col-lg-12">
            <div class="p-0">
                <app-ad-widgets [favorite]="favorite" (favoriteChange)="updateAd()" [tab]="tab"
                                [link]="'/app/tools/impot'" [edit]="false" [custom]="false"></app-ad-widgets>
            </div>
        </div>
    </div>
</div>
